/**
 * Work Schedule Status Constants
 *
 * ステータスの日本語ラベルと色分けを定義
 */

import type { WorkScheduleStatus } from '../../../shared/types/work-schedule.types';

export const WORK_SCHEDULE_STATUS_LABELS: Record<WorkScheduleStatus, string> = {
  scheduled: '予定',
  in_progress: '作業中',
  pending_approval: '承認待ち',
  completed: '完了',
  cancelled: 'キャンセル',
  postponed: '延期'
} as const;

export const WORK_SCHEDULE_STATUS_COLORS: Record<WorkScheduleStatus, string> = {
  scheduled: 'default',
  in_progress: 'processing',
  pending_approval: 'warning',
  completed: 'success',
  cancelled: 'error',
  postponed: 'default'
} as const;

/**
 * ステータスラベルを取得
 */
export function getWorkScheduleStatusLabel(status: WorkScheduleStatus): string {
  return WORK_SCHEDULE_STATUS_LABELS[status] || status;
}

/**
 * ステータスカラーを取得
 */
export function getWorkScheduleStatusColor(status: WorkScheduleStatus): string {
  return WORK_SCHEDULE_STATUS_COLORS[status] || 'default';
}
